import axios from "@/axios";

const getPayStates = async (rut) => {
  const payResponse = await axios.get(`/GetEstadoPagoLop?RutEmpresa=${rut}`)
  const pay = payResponse.data.datos.map(payResponse => payResponse.estadoDePago);
  return pay;
}

export default {
  getPayStates
};
